module.exports = __webpack_public_path__ + "static/media/TUNE_5211.0b6b5e26.jpg";